import React from 'react';
import { PropTypes } from 'prop-types';

import Modal from 'components/layout/Modal';

import Header from 'components/ModalCancelOrder/Sections/Header';
import CancelForm from 'components/ModalCancelOrder/Sections/CancelForm';

const ModalCancelOrder = ({ handleClose, t }) => {
  const renderHeader = () => <Header onClose={handleClose} t={t} />;
  return (
    <Modal
      show
      size="M"
      closeButton={false}
      withPadding={false}
      onClose={handleClose}
      renderHeader={renderHeader}
    >
      <CancelForm t={t} />
    </Modal>
  );
};

ModalCancelOrder.propTypes = {
  handleClose: PropTypes.func,
  t: PropTypes.func,
  order: PropTypes.any.isRequired,
  loads: PropTypes.any.isRequired,
};

ModalCancelOrder.defaultProps = {
  handleClose: () => ({}),
  t: (t) => t,
};

export default ModalCancelOrder;
